import React, { useState, useEffect } from "react";
import { Link, Redirect, useHistory } from "react-router-dom";
import YouTube from "react-youtube";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
//import IconButton from "@material-ui/core/IconButton";
//import Edit from "@material-ui/icons/Edit";
//import PeopleIcon from '@material-ui/icons/Group';
//import CompletedIcon from '@material-ui/icons/VerifiedUser';
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TextField from "@material-ui/core/TextField";
import { readCap } from "./api-video";
//import Divider from "@material-ui/core/Divider";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { useVideoContext } from "../libs/contextLib";

const useStyles = makeStyles((theme) => ({
  panelDetails: {
    flexDirection: "column",
    height: 300,
    overflow: "auto",
  },
  root: theme.mixins.gutters({
    maxWidth: "90%",
    margin: "auto",
    padding: theme.spacing(3),
    marginTop: theme.spacing(3),
  }),
  flex: {
    display: "flex",
    marginBottom: 20,
  },
  title: {
    margin: `${theme.spacing(3)}px 0 ${theme.spacing(3)}px ${theme.spacing(1)}px`,
    color: theme.palette.protectedTitle,
    fontSize: "1.6em",
  },
  card: {
    padding: "24px 40px 40px",
  },
  subheading: {
    margin: "10px",
    color: theme.palette.openTitle,
  },
  details: {
    margin: "16px",
  },
  sub: {
    display: "block",
    margin: "3px 0px 5px 0px",
    fontSize: "0.9em",
  },
  media: {
    height: 190,
    display: "inline-block",
    width: "100%",
    marginLeft: "16px",
  },
  icon: {
    verticalAlign: "sub",
  },
  category: {
    color: "#5c5c5c",
    fontSize: "0.9em",
    padding: "3px 5px",
    backgroundColor: "#dbdbdb",
    borderRadius: "0.2em",
    marginTop: 5,
  },
  action: {
    margin: "10px 0px",
    display: "flex",
    justifyContent: "flex-end",
  },
  statSpan: {
    margin: "7px 10px 0 10px",
    alignItems: "center",
    color: "#616161",
    display: "inline-flex",
    "& svg": {
      marginRight: 10,
      color: "#b6ab9a",
    },
  },
  enroll: {
    float: "right",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 100,
  },
}));

const VERSION_LIST = ["1.0", "1.1", "1.2", "1.3", "1.4", "1.5", "2.0", "2.1", "2.2"];

export default function Video() {
  const history = useHistory();
  const classes = useStyles();
  const { state, dispatch } = useVideoContext();
  const [curCaption, setCaption] = useState("Caption in English");
  const [pitch, setPitch] = useState(1);
  const [rate, setRate] = useState(1);
  const [player, setPlayer] = useState(undefined);
  const [capTexts, setCapTexts] = useState([]);
  const [selectedVersions, setSelectedVersions] = useState([]);
  const [selectedVersion, setSelectedVersion] = useState("1.0");
  const [startTime, setStartTime] = useState(0);
  const [speekerCheck, setSpeekerCheck] = useState(true);
  const [onPlay, setOnPlay] = useState(false);

  if (!state.curChannel) {
    history.push("/manage/channels/");
  }
  if (!state.curVideo) {
    if (state.selected.length > 0) history.push("/manage/selected");
    else history.push("/manage/videos");
  }

  const [values, setValues] = useState({
    redirect: false,
    error: "",
  });

  const { speak, cancel, speaking, supported, voices } = state.speech;

  console.log("init state.speech=", state.speech);

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    console.log("Video start state=", state);
    onLoadCaptions(signal);

    return function cleanup() {
      if (state.delaySpeakId) {
        clearTimeout(state.delaySpeakId);
        dispatch({ type: "setDelaySpeakId", payload: undefined });
        player.stopVideo();
      }

      abortController.abort();
    };
  }, []);

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    if (state.curVideo.text_en) speakCaptionChain(0, state.curVideo.text_en, 0);

    return function cleanup() {
      if (state.delaySpeakId) {
        clearTimeout(state.delaySpeakId);
        dispatch({ type: "setDelaySpeakId", payload: undefined });
        player.stopVideo();
      }

      abortController.abort();
    };
  }, [startTime]);

  const onLoadCaptions = async (signal) => {
    if (!state.curVideo.text_en) {
      try {
        const newSelectedVersions = [];
        const newCapTexts = [];
        let lastSerVer;
        let last_text_en;
        let lastVideoCap;
        for (let ver of VERSION_LIST) {
          const params = {
            videoId: state.curVideo.videoId,
            version: ver,
          };

          const videoCap = await readCap(params, signal);
          console.log("onLoadCaptions after read videoCap=", videoCap);
          const text_en = videoCap.text_en ?? [];
          if (text_en.length > 0) {
            newSelectedVersions.push(ver);
            console.log("newSelectedVersions=", newSelectedVersions);
            newCapTexts.push({ version: ver, text_en });
            console.log("newCapTexts=", newCapTexts);
            lastSerVer = ver;
            lastVideoCap = videoCap;
            lastVideoCap.text_en = text_en;
          }
        }
        setSelectedVersions(newSelectedVersions);
        setCapTexts(newCapTexts);
        setSelectedVersion(lastSerVer);
        const newVideo = { ...state.curVideo, ...lastVideoCap };
        console.log("onLoadCaptions newVideo=", newVideo);
        dispatch({ type: "setVideo", payload: newVideo });
      } catch (err) {
        console.log("err=", err);
      }
    }
  };

  if (values.redirect) {
    return <Redirect to={"/manage/videos"} />;
  }
  const CaptionContent = () => (
    <>
      {state.curVideo.text_en &&
        state.curVideo.text_en.map((el) => (
          <Typography paragraph key={el.start}>
            {el.text.replaceAll("&#39;", "'")}
          </Typography>
        ))}
    </>
  );
  const opts = {
    height: "390",
    width: "640",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };
  const onPlayerReady = (event) => {
    console.log("onPlayerReady event.target=", event.target);
    if (state.speaker !== "original") event.target.mute();
    event.target.pauseVideo();
    //event.target.playVideo();
    setPlayer(event.target);
  };

  const onYoutubePlay = () => {
    //player.playVideo();
    let curPlayTime = 0;
    setOnPlay(true);
    curPlayTime = player.getCurrentTime();
    console.log("onYoutubePlay curPlayTime=", curPlayTime);
    const text_en = state.curVideo.text_en;
    if (!text_en) return;
    //console.log('text_en=',text_en);
    let newStart = 0;
    for (let i = 0; i < text_en.length; i += 1) {
      if (text_en[i].start > curPlayTime) break;
      newStart = i;
    }
    console.log("onYoutubePlay newStart=", newStart);
    speakCaptionChain(newStart, state.curVideo.text_en, 0);
  };

  const onYoutubePause = () => {
    //player.pauseVideo();
    console.log("onYoutubePause");
    setOnPlay(false);
    cancel();
    if (state.delaySpeakId) {
      clearTimeout(state.delaySpeakId);
      dispatch({ type: "setDelaySpeakId", payload: undefined });
    }
  };

  function speakCaptionChain(i, textList, delay) {
    if (i >= textList.length) return;
    let text = textList[i].text;
    text = text.replaceAll("&#39;", "'");
    text = text.replaceAll("&quot;", '"');

    delay = delay ?? (i === 0 ? textList[i].start : textList[i].start - textList[i - 1].start);
    const id = setTimeout(() => {
      console.log("speakCaptionChain i, onPlay=", i, onPlay);
      setCaption(text);
      speakCaption(text);
      speakCaptionChain(i + 1, textList);
    }, delay * 1000);
    dispatch({ type: "setDelaySpeakId", payload: id });
  }

  const speakCaption = (text) => {
    // Filtering some useless string
    let newtext = text.replace(/\[[Mm]usic\]|Ah|ooh|uh/g, "");
    newtext = newtext.replaceAll("&#39;", "'");
    newtext = newtext.replaceAll("&quot;", '"');
    newtext = newtext.trim();
    console.log("newtext=", newtext);
    if (newtext.length === 0) return;

    const params = { text: newtext, voice: state.voice, rate, pitch };
    //console.log("speakCaption params=", params);
    speak(params);
  };

  const handleSelectVersion = (event) => {
    console.log("handleSelectVersion event.target=", event.target);
    const selVer = event.target.value;
    console.log("selectedVersions=", selectedVersions);
    console.log("selVer=", selVer);
    setSelectedVersion(selVer);
    const sel_text_en = capTexts.filter((cap) => cap.version === selVer)[0].text_en;
    console.log("sel_text_en=", sel_text_en);
    const newVideo = { ...state.curVideo, text_en: sel_text_en };
    dispatch({ type: "setVideo", payload: newVideo });

    // Start Play From Start
    setOnPlay(false);
    cancel();
    if (state.delaySpeakId) {
      clearTimeout(state.delaySpeakId);
      dispatch({ type: "setDelaySpeakId", payload: undefined });
    }
    player.stopVideo();
    //player.pauseVideo();
    setOnPlay(true);
    setStartTime(0);
  };

  const handleSpeekerChange = (event) => {
    console.log("handleSpeekerChange event.target=", event.target);
    console.log("handleSpeekerChange speekerCheck=", speekerCheck);
    setSpeekerCheck(event.target.checked);
    if (event.target.checked) {
      player.mute();
      let curPlayTime = player.getCurrentTime();
      console.log("handleSpeekerChange curPlayTime=", curPlayTime);
      const text_en = state.curVideo.text_en;
      if (!text_en) return;
      //console.log('text_en=',text_en);
      let newStart = 0;
      for (let i = 0; i < text_en.length; i += 1) {
        if (text_en[i].start > curPlayTime) break;
        newStart = i;
      }
      console.log("handleSpeekerChange newStart=", newStart);
      speakCaptionChain(newStart, state.curVideo.text_en, 0);
    } else {
      cancel();
      if (state.delaySpeakId) {
        clearTimeout(state.delaySpeakId);
        dispatch({ type: "setDelaySpeakId", payload: undefined });
      }
      player.unMute();
    }
  };
  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <Typography type="title" className={classes.title}>
          Play Video
        </Typography>
        <CardHeader title={state.curVideo.title} />
        <CardContent>
          <div className={classes.flex}>
            <div className={classes.details}>
              <YouTube
                startSeconds={startTime}
                videoId={state.curVideo.videoId}
                opts={opts}
                onReady={onPlayerReady}
                onPlay={onYoutubePlay}
                onPause={onYoutubePause}
              />
            </div>
            {
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>Subtitle[English]</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.panelDetails}>
                  <CaptionContent />
                </AccordionDetails>
              </Accordion>
            }
          </div>
          <div>
            <Typography>{curCaption}</Typography>
          </div>
          {selectedVersions.length > 1 && (
            <FormControl color="primary" variant="outlined" className={classes.formControl}>
              <InputLabel>Ver.</InputLabel>
              <Select value={selectedVersion} onChange={handleSelectVersion} label="Ver.">
                {selectedVersions.map((ver) => (
                  <MenuItem key={ver} value={ver}>
                    {ver}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          <FormControlLabel
            control={
              <Switch
                checked={speekerCheck}
                onChange={handleSpeekerChange}
                name="speekerCheck"
                color="primary"
              />
            }
            label="Speeker"
          />
        </CardContent>
      </Card>
    </div>
  );
}
